import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Button } from '@material-ui/core';

function getModalStyle() {
  return {
    top: `${50}%`,
    left: `${50}%`,
    transform: `translate(-50%, -50%)`,
    outline: 0,
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 'auto',
    backgroundColor: 'white',
    padding: theme.spacing(2, 4, 3),
    display: 'flex',
    boxSizing: 'border-box',
    maxHeight: '100vh',
    overflowY: 'visible',
    borderRadius: '5px',
  },
}));

const RenderPropModal = ({
  children,
  cardDisplay,
  containerStyle,
  childContainerStyle,
  enterHover,
  exitHover,
  manageHandleOpen,
  manageHandleClose,
  modalStyle,
}) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalPositioning] = useState(getModalStyle);
  const [open, setOpen] = useState(false);

  const handleOpen = e => {
    if (e) e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div css={{ ...containerStyle }}>
      <Modal
        open={open}
        onClick={e => e.stopPropagation()}
        onBackdropClick={handleClose}
      >
        <div
          className={classes.paper}
          style={{ ...modalPositioning, ...modalStyle }}
        >
          {cardDisplay({ handleClose })}
          {manageHandleClose && (
            <Button
              color="primary"
              variant="contained"
              onClick={handleClose}
              style={{ marginTop: '15px' }}
            >
              Close
            </Button>
          )}
        </div>
      </Modal>
      <div
        css={{ ...childContainerStyle }}
        onClick={e => {
          manageHandleOpen && handleOpen(e);
        }}
        onFocus={enterHover}
        onBlur={enterHover}
        onMouseOver={e => {
          e.stopPropagation();
          enterHover && enterHover();
        }}
        onMouseOut={exitHover}
      >
        {children({ handleOpen })}
      </div>
    </div>
  );
};

export default RenderPropModal;
